import FileDownload from '../atoms/FileDownload'
import { MotifCard, MotifCardBody } from '@ey-xd/motif-react'
import React from 'react'

const WorkspaceRelatedDocumentsCard = (props: any) => {
    const {info} = props;
    return (
        <MotifCard className="!h-full">
            <MotifCardBody>
                <h6 className="!font-bold mb-10">Related documents</h6>
                <div className="flex flex-col gap-3 justify-center mb-2">
                    {info.map((item: any, index: number) => (
                        <FileDownload key={index} {...item}  />
                    ))}
                </div>
                {/* <div className="flex justify-end">
                    <a className="!font-bold  !text-[#188CE5] !cursor-pointer">View all</a>
                </div> */}
            </MotifCardBody>
        </MotifCard>
    )
}

export default WorkspaceRelatedDocumentsCard